/**
 * Office.js Capability Detection
 * Helpers to check if specific Office.js APIs are available
 */

/* global Excel */

/**
 * Check if getSelectedRanges() is supported
 * @param ctx - Excel RequestContext
 * @returns true if getSelectedRanges() method exists
 */
export function supportsGetSelectedRanges(ctx: Excel.RequestContext): boolean {
  return typeof (ctx.workbook as any).getSelectedRanges === "function";
}
